import React, { ChangeEvent, KeyboardEvent } from 'react'

interface CodeInputProps {
  length: number
  value: string
  onChange: (value: string) => void
}

const CodeInput: React.FC<CodeInputProps> = ({ length, value, onChange }) => {
  const codeArray = value.split('').concat(Array(length).fill(''))

  const handleChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const newCode = [...codeArray]
    newCode[index] = e.target.value
    onChange(newCode.slice(0, length).join(''))

    if (e.target.value && index < length - 1) {
      const nextInput = e.target.nextSibling as HTMLInputElement
      if (nextInput) {
        nextInput.focus()
      }
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace' && !codeArray[index] && index > 0) {
      const prevInput = (e.target as HTMLInputElement)
        .previousSibling as HTMLInputElement
      if (prevInput) {
        prevInput.focus()
      }
    }
  }

  return (
    <div className='flex justify-center gap-2'>
      {codeArray.slice(0, length).map((digit, index) => (
        <input
          key={index}
          type='tel'
          maxLength={1}
          value={digit}
          onChange={e => handleChange(e, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          className='w-10 h-12 bg-white rounded-md flex items-center justify-center text-xl font-bold border-2 text-center'
        />
      ))}
    </div>
  )
}

export default CodeInput
